<template lang="html">
	<div class="inner-modal">
		<div class="head-modal head-modal-light row">
			<div class="left">
				<div class="head-modal-title-light text-center">
					<template v-if="!paymentMethodId">Ajouter un moyen de paiement</template>
					<template v-else>Modifier un moyen de paiement</template>
				</div>
			</div>
		</div>
    <h5 class="payment-method-type-name text-center">Carte bancaire</h5>
    <div class="body-modal">
			<form class="form-ui column default-form-ui">
				<div class="form-elem-container">
					<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('nameOnCard')}">
						<label for="nameOnCard">Nom du porteur</label>
						<input v-validate="'required'" type="text" name="nameOnCard" v-model="nameOnCard">
					</div>
					<div v-if="errors.has('nameOnCard')" class="error-message">{{ errors.first('nameOnCard') }}</div>
				</div>
        <template v-if="!paymentMethodId">
          <div class="form-elem-container">
            <div class="ctn-input ctn-label" v-inputUI>
              <div class="StripeElement stripe-input empty" id="creditCardCardNumber"></div>
              <label class="stripe-label" for="creditCardCardNumber">Numéro de carte</label>
            </div>
          </div>
          <div class="form-elem-container">
            <div class="ctn-input ctn-label" v-inputUI>
              <div class="StripeElement stripe-input empty" id="creditCardExpiration"></div>
              <label class="stripe-label" for="creditCardExpiration">Date d'expiration</label>
            </div>
          </div>
          <div class="form-elem-container">
            <div class="ctn-input ctn-label" v-inputUI>
              <div class="StripeElement stripe-input empty" id="creditCardSecurityCode"></div>
              <label class="stripe-label" for="creditCardSecurityCode">CCV</label>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="form-elem-container">
            <div class="" v-inputUI :class="{error: errors.has('cardNumber')}">
              <p class="label">Numéro de carte</p>
              <p class="value">
                {{capitalizeText(data.card_brand)}} ******{{data.card_last4}}
              </p>
            </div>
          </div>
        </template>

        <div class="check-container row">
          <radio-box :value="isDefaultPaymentMethod" @change="isDefaultPaymentMethod=$event"/>
          <div class="link">
            Par défaut
          </div>
        </div>

        <p class="sr-field-error text-red"></p>
				<div class="ctn-cta right row">
					<div class="btn btn-gold" @click="close">Annuler</div>
					<div class="btn btn-red" @click="send">Valider</div>
				</div>
				<div class="row secure-payment-msg-row">
				<p>
					<span class="icon-doc-private"></span> Paiement 100% Sécurisé (HTTPS)
				</p>
				</div>
			</form>
		</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomSelect from '@/common/components/Form/CustomSelect'
import StripeForm from '@/common/services/StripeForm'

export default {
	props: ['data'],
	components: {
		CustomSelect
	},
	data () {
		return {
			nameOnCard: null,
			expMonth: null,
			expYear: null,
			isDefaultPaymentMethod: false,
			stripeForm: null,
			paymentMethodId: null
		}
	},
	mounted () {
		this.stripeForm = new StripeForm({
			submitBtnSelector: '.submit-card-btn',
			clientSecret: this.clientSecret
		})

		if (typeof this.data.id !== 'undefined') {
			this.nameOnCard = this.data.name_on_card
			this.paymentMethodId = this.data.id
			this.isDefaultPaymentMethod = this.data.is_default
		}

		this.stripeForm.initializeForm()
	},
	methods: {
		close () {
			this.$emit('close')
		},
		capitalizeText (text) {
			return text.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase() })
		},
		showCardError (error) {
			let errorMsg = document.querySelector('.sr-field-error')
			errorMsg.textContent = error.message
			setTimeout(function () {
				errorMsg.textContent = ''
			}, 8000)
		},
		storePaymentMethod (result) {
			if (this.paymentMethodId) {
				this.processPaymentMethodEdition()
			} else {
				this.processPaymentMethodAdding(result)
			}
		},
		processPaymentMethodAdding (result) {
			this.$store.dispatch('newPaymentMethod', {
				name_on_card: this.nameOnCard,
				stripe_payment_method_id: result.setupIntent.payment_method,
				is_default: this.isDefaultPaymentMethod
			}).then(() => {
				this.$store.dispatch('getPaymentMethods')

				this.close()
				this.$notify({
					type: 'success',
					group: 'default',
					title: 'Carte bancaire ajoutée',
					text: 'La carte bancaire a bien été ajouté'
				})
			}).catch(() => {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Erreur',
					text: 'Une erreur est survenue, merci de réessayer'
				})
			})
		},
		processPaymentMethodEdition () {
			this.$store.dispatch('editPaymentMethod', {
				name_on_card: this.nameOnCard,
				exp_month: this.expMonth,
				exp_year: this.expYear,
				payment_method_id: this.paymentMethodId,
				is_default: this.isDefaultPaymentMethod
			}).then(() => {
				this.$store.dispatch('getPaymentMethods')
				this.close()
				this.$notify({
					type: 'success',
					group: 'default',
					title: 'Carte bancaire modifiée',
					text: 'La carte bancaire a bien été modifiée'
				})
			}).catch(() => {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Erreur',
					text: 'Une erreur est survenue, merci de réessayer'
				})
			})
		},
		send () {
			let billingDetails = {
				name: this.nameOnCard,
				email: this.user.email
			}

			if (this.paymentMethodId) {
				this.storePaymentMethod({})
				return
			}

			this.stripeForm.confirmCardSetup(billingDetails).then((result) => {
				if (result.error) {
					this.showCardError(result.error)
				} else {
					this.storePaymentMethod(result)
				}
			})
		}
	},
	computed: {
		...mapGetters({
			user: 'user',
			clientSecret: 'clientSecret'
		})
	}
}
</script>

<style lang="scss" scoped>

	.head-modal {
		/*justify-content: flex-start;*/
	}

	.body-modal {
		padding-top: 0.5rem!important;

		form {
			align-items: flex-start;
			.form-elem-container {
				width: 100%;
			}
		}
	}

	.custom-select {
		width: 200px;
	}

  .payment-method-type-name {
    padding-bottom: 10px;
    padding-top: 10px;
    border-bottom: 1px solid #F2F2F3;
    font-weight: bold;
  }

  .ctn-label label {
    text-transform: initial !important;
  }

  .check-container {
    justify-content: flex-start;
    margin-bottom: 1rem;
    .link {
      margin-left: 0.5rem;
      color: #797979;
      text-decoration: none;
    }
  }

  .form-elem-unditable {
    margin-top: 10px;
    margin-bottom: 20px;

    .label {
      font-size: 0.6rem;
      font-family: "Lato Bold";
      opacity: 0.5;
      margin-bottom: 5px;
    }
  }

  .secure-payment-msg-row {
  margin-top: 20px;
  font-size: 0.8rem;
  }

  .stripe-input {
  padding: 0.8rem;
  }

</style>



// WEBPACK FOOTER //
// src/views/Documents/PaymentMethodModal/PaymentMethod.vue